<template>
  <v-row dense :v-if="isNotification">
    <v-col>
      <v-alert
        class="customPointer"
        v-for="(notification, index) in notifications"
        :key="index"
        :prominent="!smallDisplay"
        dense
        text
        :type="notification.type"
        width="100%"
        elevation="1"
      >
        <v-row align="center">
          <v-col class="grow">
            {{ $t(notification.message) }}
          </v-col>
          <v-col class="shrink" :cols="isSmallDisplay" align-self="center" v-if="notification.hasTextField">
            <v-text-field
              ref="alertField"
              single-line
              outlined
              hide-details
              dense
              :light="true"
              :background-color="notification.textFieldBgColor"
              :rules="getRules(notification)"
              v-model="fieldValue"
              :type="notification.textFieldType"
              :placeholder="$t(notification.textFieldPlaceholder)"
            ></v-text-field>
          </v-col>
          <v-col class="shrink" :cols="isSmallDisplay">
            <v-btn
              outlined
              small
              :disabled="isLoading"
              v-if="notification.dismissText"
              :color="notification.type"
              @click="popNotification(index)"
            >
              {{ $t(notification.dismissText) }}
            </v-btn>
            <v-btn
              class="ml-2"
              :loading="isLoading"
              small
              :color="notification.type"
              @click="processNotification(notification, index)"
            >
              {{ $t(notification.actionText) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { NotificationHandler } from "@/lib/notification/NotificationHandler";
import { extendetPhoneRule } from "@/lib/rules/contactRule";
import { INotification } from "@/store/interface/notification.interface";
import { NotificationModule } from "@/store/modules/notification.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Notifications extends Vue {
  informationsChecked = false;
  isLoading = false;

  /** Value to pass to notification.action */
  fieldValue = "";

  get isSmallDisplay(): string {
    if (this.smallDisplay) {
      return "12";
    } else {
      return "auto";
    }
  }

  get smallDisplay(): boolean {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return true;
      case "sm":
        return true;
      case "md":
        return false;
      case "lg":
        return false;
      case "xl":
        return false;
    }
    return false;
  }

  async mounted() {
    if (!NotificationModule.isNotificationsLoaded) {
      try {
        NotificationModule.setIsNotificationsLoaded(true);
        await NotificationHandler.check();
      } catch (error) {
        this.$log.error(error);
      }
    }
  }

  get isNotification() {
    return NotificationModule.isNotification;
  }

  get notifications() {
    return NotificationModule.notifications;
  }

  popNotification(index: number) {
    NotificationModule.popNotification(index);
  }

  async processNotification(notification: INotification, index: number) {
    if (notification.action) {
      try {
        this.isLoading = true;

        // Check if fieldValue is valid before passing it to the action function
        const fieldValue = this.$refs.alertField && (this.$refs.alertField as any)[0].hasError ? null : this.fieldValue;
        await notification.action(fieldValue);

        if (notification.closeOnSuccess) {
          this.popNotification(index);
        }
      } catch (error) {
        this.$log.error(error);
      } finally {
        this.isLoading = false;
      }
    }

    if (notification.location) {
      this.$router.push(notification.location);
      this.popNotification(index);
    }
  }

  getRules(notification: INotification) {
    const rules = [];

    if (notification.textFieldType === "tel") {
      rules.push(extendetPhoneRule());
    }

    return rules;
  }
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
